

































































import Vue from 'vue'
import { cloneDeep } from 'lodash'
import { WarehouseMaterialStockServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
const wmsp = new WarehouseMaterialStockServiceProxy()

export default Vue.extend({
  // 备品备件
  name: 'SparePartsTable',
  props: ['tableData', 'readOnly'],
  data() {
    return {
      // tableColumns: [],
      newTableData: [],
      materialList: [], // 备品备件列表
      filterMaterialList: [], // 备品备件列表
      materialKey: '',
      fetching: false,
      count: 0
    }
  },
  computed: {
    tableColumns() {
      let col = [
        {
          title: this.$t('page_material_ware_out_code'),
          dataIndex: 'orderCode',
          key: 'orderCode',
          width: 200,
          scopedSlots: { customRender: 'orderCode' }
        },
        {
          title: this.$t('page_business_material_property_spare_parts'),
          dataIndex: 'materialId',
          key: 'materialId',
          width: 200,
          scopedSlots: { customRender: 'material' }
        },
        {
          title: this.$t('page_material_check_area'),
          dataIndex: 'areaName',
          width: 200,
          ellipsis: true
        },
        {
          title: this.$t('page_material_check_location'),
          dataIndex: 'locationName',
          width: 200,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_total_inventory'),
          dataIndex: 'stockSumNum',
          key: 'stockSumNum',
          width: 200,
          scopedSlots: { customRender: 'stockSumNum' }
        },
        {
          title: this.$t('page_tpm_record_table_location_num'),
          dataIndex: 'locationNum',
          key: 'locationNum',
          width: 200,
          scopedSlots: { customRender: 'locationNum' }
        },
        {
          title: this.$t('page_plan_delivery_quantity'),
          dataIndex: 'stockOutNum',
          key: 'stockOutNum',
          width: 200,
          scopedSlots: { customRender: 'stockOutNum' }
        },
        {
          title: this.$t('page_tpm_record_table_issue'),
          dataIndex: 'issue',
          key: 'issue',
          width: 200,
          scopedSlots: { customRender: 'issue' }
        }
      ]
      if (!this.readOnly) {
        // 可编辑
        return [
          {
            title: this.$t('page_tenant_operation'),
            dataIndex: 'action',
            key: 'action',
            width: 100,
            scopedSlots: { customRender: 'action' }
          },
          ...col
        ]
      } else {
        // 只读
        return col
      }
    }
  },
  watch: {
    tableData: {
      handler(val) {
        this.newTableData = []
        this.count = 0
        if (val && val.length) {
          let temp = cloneDeep(val)
          temp.map((item, index) => {
            return (item.key = index + 'edit')
          })
          this.count = val.length
          this.newTableData = temp
          this.resetList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.materialKey = ''
    this.getMaterialList()
  },
  methods: {
    // 备品备件列表
    async getMaterialList() {
      const values: any = {
        keyWord: this.materialKey,
        property: 4,
        typeId: ''
      }
      const res = await wmsp.getStockMaterial(values)
      this.materialList = res
      this.filterMaterialList = res.map((item) => ({
        label: item.name + '(' + item.areaName + '-' + item.locationName + ')',
        value: item.materialId + item.areaId + item.locationId
      }))
      this.fetching = false
      if (this.newTableData.length) {
        this.resetList()
      }
    },
    fetchUser(value) {
      this.materialKey = value
      if (!this.filter) {
        this.fetching = true
        this.getMaterialList()
      }
    },
    onDelete(key) {
      let temp = [...this.newTableData]
      let index = temp.findIndex((item) => item.key === key)
      temp.splice(index, 1)
      this.newTableData = [...temp]
      this.resetList()
    },
    onChange(value, key) {
      let material = this.materialList.find(
        (item) => item.materialId + item.areaId + item.locationId === value
      )
      let temp = [...this.newTableData]
      temp.map((item) => {
        if (item.key === key) {
          item.materialId = material.materialId
          item.materialCode = material.code
          item.materialName = material.name
          item.areaId = material.areaId
          item.locationId = material.locationId
          item.areaName = material.areaName
          item.locationName = material.locationName
          item.stockSumNum = material.stockSumNum
          item.locationNum = material.locationNum
        }
      })
      this.newTableData = [...temp]
      this.materialKey = ''
      this.resetList()
    },
    onChangeIssue(value, key) {
      const newData = [...this.newTableData]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target['issue'] = value
        this.newTableData = newData
      }
    },
    resetList() {
      let keys = this.newTableData.map((item) => item.materialId + item.areaId + item.locationId)
      let temp = cloneDeep(this.filterMaterialList)
      temp.map((item) => {
        if (keys.includes(item.value)) {
          item.disabled = true
        } else {
          delete item.disabled
        }
      })
      this.filterMaterialList = cloneDeep(temp)
    },
    onAdd() {
      const { count, newTableData } = this
      const newData = {
        key: count + 'add',
        materialId: '',
        orderCode: '',
        stockSumNum: undefined,
        locationNum: undefined,
        stockOutNum: undefined,
        issue: 0
      }
      this.newTableData = [...newTableData, newData]
      this.count = count + 1
      this.$nextTick(() => {
        // 滚动条始终保持在底部
        let box = document.getElementsByClassName('ant-table-body')
        let height = box[1].scrollHeight
        box[1].scrollTo(0, height)
      })
    },
    // 取有值的数据
    getList() {
      return this.newTableData.filter((item) => !!item.materialId)
    }
  }
})
